import {
  EstateImprovement,
  EstateSubscription,
} from "@1games-ru/region-shared/dist/enums/estate/estate";
import { useTranslation } from "react-i18next";
import { CheckIcon } from "@/shared/icons";

type Props = {
  isBought?: boolean;
  isActive?: boolean;
  type: EstateImprovement | EstateSubscription;
  icon: (props: { className?: string }) => JSX.Element;
  level?: number;
  onClick: () => void;
  isSubscription?: boolean;
};

export default function EstateImprovementsItem({
  isBought,
  isActive,
  type,
  icon: IconComponent,
  level,
  onClick,
  isSubscription,
}: Props) {
  const { t, i18n } = useTranslation("estate");

  const cardTitle = i18n.exists(`estate:estate.improvements.types.${type}.name`)
    ? t(`estate.improvements.types.${type}.name`)
    : type;

  return (
    <button
      className="group relative flex flex-col justify-between w-[calc(25%-0.28125rem)] h-[7.75rem] p-5 bg-dark-800 rounded-2xl"
      type="button"
      onClick={onClick}
    >
      <IconComponent className="relative z-2 size-6.5 transition-all duration-200 ease-in-out group-hover:text-accent-solid" />
      <p className="relative z-2 max-w-28 text-15 font-bold text-left pointer-events-none">
        {cardTitle}
      </p>
      <div className="absolute top-0 left-0 size-full bg-gradient-to-br from-[#FF4E4E]/30 to-transparent rounded-2xl transition-all duration-200 ease-in-out opacity-0 hover:opacity-100" />
      {isBought && !isSubscription && (
        <div className="absolute right-0 top-0 flex items-center gap-1.5 h-8 rounded-bl-2xl rounded-tr-2xl pointer-events-none">
          <div className="flex items-center gap-1.5 w-full h-8 py-[0.6875rem] px-2.5 text-11 font-bold leading-none uppercase">
            <CheckIcon
              size={14}
              className="relative z-1 text-[#84FF97] transition-all duration-200 ease-in-out group-hover:text-accent-solid"
            />{" "}
            {t("estate.improvements.bought")}
          </div>
          <span className="absolute top-0 left-0 size-full bg-gradient-to-r from-[#FF4E4E]/30 to-transparent rounded-bl-2xl rounded-tr-2xl opacity-0 transition-all duration-200 ease-in-out group-hover:opacity-100" />
          <span className="absolute top-0 left-0 size-full bg-gradient-to-r from-[#21652C]/30 to-transparent rounded-bl-2xl rounded-tr-2xl opacity-100 transition-all duration-200 ease-in-out group-hover:opacity-0" />
        </div>
      )}
      {isSubscription && isActive && (
        <div className="absolute right-0 top-0 flex items-center gap-1.5 h-8 rounded-bl-2xl rounded-tr-2xl pointer-events-none">
          <div className="flex items-center gap-1.5 w-full h-8 py-[0.6875rem] px-2.5 text-11 font-bold leading-none uppercase">
            <div className="size-1.5 m-0.5 rounded-2xl bg-[#84FF97] transition-all duration-200 ease-in-out group-hover:bg-[#FD4D4D]" />
            {t("estate.improvements.statusesList.active")}
          </div>
          <span className="absolute top-0 left-0 size-full bg-gradient-to-r from-[#FF4E4E]/30 to-transparent rounded-bl-2xl rounded-tr-2xl opacity-0 transition-all duration-200 ease-in-out group-hover:opacity-100" />
          <span className="absolute top-0 left-0 size-full bg-gradient-to-r from-[#21652C]/30 to-transparent rounded-bl-2xl rounded-tr-2xl opacity-100 transition-all duration-200 ease-in-out group-hover:opacity-0" />
        </div>
      )}
      {!isSubscription && level > 0 && (
        <p className="absolute z-2 right-4.5 bottom-4.5 py-1 px-1.5 text-11 font-bold uppercase bg-[#D73434]/20 rounded-[0.3125rem]">
          <span className="text-[#FD4D4D]">{level}</span> {t(`estate.improvements.level`)}
        </p>
      )}
    </button>
  );
}
